@if (inInputMode) {
  <submit-passthrough-permit [(application)]="application" (saveActivated)="saveForLater($event)" (submitActivated)="submitApplication($event)"></submit-passthrough-permit>
}
@if (inEditMode) {
  <edit-landowner-application [(application)]="application" (saveActivated)="saveForLater($event)" (submitActivated)="submitApplication($event)" (cancelConfirmed)="cancelEdit($event)"></edit-landowner-application>
}
@if (inReviewMode) {
  <review-landowner-application [(application)]="application"></review-landowner-application>
}
<a style="display:none" href="" target="_blank" #downloadLink></a>
